import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AnimateHeight from 'react-animate-height';

import { getKoalaSightingsByUser, showEditKoalaSighting, getAllKoalaSightings } from '../../actions/mainview/mainview';

const SightingList = props => {

  const dispatch = useDispatch(),
        appProps = useSelector(store => store.app),
        mainviewProps = useSelector(store => store.mainview),
        [sightingList, setSightingList] = useState([]),
        [currentPage, setCurrentPage] = useState(1),
        [includeVerified, setIncludeVerified] = useState(props.retrieveOwnSightings ? null : true),
        [onlyHealthy, setOnlyHealthy] = useState(null),
        [totalPages, setTotalPages] = useState(1),
        [showFilters, setShowFilters] = useState(false),
        [height, setHeight] = useState(0),
        isAdmin = appProps.loggedInUser?.is_admin,
        isAkf = appProps.loggedInUser?.is_akfstaff;

  useEffect(() => {
    props.retrieveOwnSightings ?
      dispatch(getKoalaSightingsByUser(currentPage, includeVerified, onlyHealthy)) :
      dispatch(getAllKoalaSightings(currentPage, includeVerified, onlyHealthy)); 
  }, [dispatch]);

  useEffect(() => {
    if (props.retrieveOwnSightings) {
      setSightingList(mainviewProps.userKoalaSightingListData?.results);
      setCurrentPage(mainviewProps.userKoalaSightingListData?.current_page);
      setTotalPages(mainviewProps.userKoalaSightingListData?.total_pages);
    }
    else {
      setSightingList(mainviewProps.adminSightingListData?.results);
      setCurrentPage(mainviewProps.adminSightingListData?.current_page);
      setTotalPages(mainviewProps.adminSightingListData?.total_pages);
    }
  }, [props.retrieveOwnSightings ? mainviewProps.userKoalaSightingListData : mainviewProps.adminSightingListData]);

  const _handleFormSubmit = e => {
    e.preventDefault();

    props.retrieveOwnSightings ?
      dispatch(getKoalaSightingsByUser(currentPage, includeVerified, onlyHealthy)) :
      dispatch(getAllKoalaSightings(currentPage, includeVerified, onlyHealthy)); 
  }

  const _showAll = () => {
    setIncludeVerified(true);
    setOnlyHealthy(null);
    
    props.retrieveOwnSightings ?
      dispatch(getKoalaSightingsByUser(currentPage)) :
      dispatch(getAllKoalaSightings(currentPage)); 
  }

  const _nextPage = () => {
    props.retrieveOwnSightings ?
      dispatch(getKoalaSightingsByUser(null, null, null, null, mainviewProps.adminSightingListData?.next)) :
      dispatch(getAllKoalaSightings(null, null, null, null, mainviewProps.adminSightingListData?.next));
  }

  const _prevPage = () => {
    props.retrieveOwnSightings ?
      dispatch(getKoalaSightingsByUser(null, null, null, mainviewProps.adminSightingListData?.previous, null)) :
      dispatch(getAllKoalaSightings(null, null, null, mainviewProps.adminSightingListData?.previous, null));
  }
  
  const _toggleFilters = () => {
    setHeight(!showFilters ? 'auto' : 0);
    setShowFilters(!showFilters);
  }

  return (
    <>
      {
        !props.retrieveOwnSightings &&
        sightingList?.length > 1 &&
        <>
          <AnimateHeight duration={ 300 } height={ height }>
            <form onSubmit={ e => _handleFormSubmit(e) } className="form">
              <div className="form__group form__group--horizontal">
                {
                  isAdmin || isAkf ?
                  (
                    <>
                      {/* <fieldset className="form__item-container">
                        <p className="form__label">{ onlyVerified === 'null' || onlyVerified === null ? 'No verified filter' : onlyVerified === 'true' ? 'Show verified sightings' : 'Hide verified sightings' }</p>
                        <div className="form__radio" title="No verified filter">
                          <input type="radio" className="form__radio-input" id="verifiedDefault" name="verifiedFilter" value="null" onChange={ e => setIncludeVerified(e.currentTarget.value) } defaultChecked />
                          <label htmlFor="verifiedDefault" className="form__radio-label">No verified filter</label>
                        </div>
                        <div className="form__radio" title="Filter to show verified sightings">
                          <input type="radio" className="form__radio-input" id="verifiedOn" name="verifiedFilter" value="true" onChange={ e => setIncludeVerified(e.currentTarget.value) } />
                          <label htmlFor="verifiedOn" className="form__radio-label">Show verified sightings</label>
                        </div>
                        <div className="form__radio" title="Filter to hide verified sightings">
                          <input type="radio" className="form__radio-input" id="verifiedOff" name="verifiedFilter" value="false" onChange={ e => setIncludeVerified(e.currentTarget.value) } />
                          <label htmlFor="verifiedOff" className="form__radio-label">Hide verified sightings</label>
                        </div>
                      </fieldset> */}
                      <fieldset className="form__item-container">
                        <p className="form__label">{ includeVerified ? 'Include' : 'Exclude' } verified sightings</p>
                        <div className="form__switch" style={{ margin: '.8rem auto 0' }}>
                          <input type="checkbox" name="verified" className="form__switch-checkbox" id="verified" defaultChecked onChange={ e => setIncludeVerified(e.currentTarget.checked) } />
                          <label className="form__switch-label" htmlFor="verified"></label>
                        </div>
                      </fieldset>
                      
                      {/* <fieldset className="form__item-container">
                        <p className="form__label">{ onlyHealthy ? 'Include' : 'Exclude' } only healthy</p>
                        <div className="form__switch">
                          <input type="checkbox" name="healthy" className="form__switch-checkbox" id="healthy" onChange={ e => setOnlyHealthy(e.target.checked) } />
                          <label className="form__switch-label" htmlFor="healthy"></label>
                        </div>
                      </fieldset> */}
                    </>
                  ) : null
                }
              </div>

              <div className="form__button-group">
                <button onClick={ () => _showAll() } className="form__button button button--hollow" type="reset" title="Reset this search">Reset</button>
                <button type="submit" className="form__button button" disabled={ appProps.loading } title="Search">Search</button>
              </div>
            </form>
          </AnimateHeight>
          <div className="form__filter-toggle" onClick={ () => _toggleFilters() }>
            <span className="form__filter-toggle-text">{ showFilters ? 'Hide' : 'Show' } filters <i className={ `fas fa-${ showFilters ? 'chevron-up' : 'chevron-down' }` } style={{ marginLeft: 5 }}></i></span>
          </div>
        </>
      }

      {
        appProps.loading ?
        (
          <div className="search-list__loader">Loading&hellip;</div>
        ) :
        (  
          <ul className={ `search-list search-list--reduced ${ sightingList !== undefined && sightingList.length > 25 ? 'search-list--restricted' : '' }` }>
            {
              sightingList !== null &&
              <>
                {
                  sightingList.length > 0 ?
                  (
                    sightingList.sort((a, b) => new Date(b.datetime_of_sighting) - new Date(a.datetime_of_sighting)).map((item, i) => (
                      <li key={ i } className="search-list__item">
                        <figure className="search-list__item-info">

                          {
                            item.datetime_of_sighting !== null &&
                            <figcaption className="search-list__item-text">{ new Date(item.datetime_of_sighting).toLocaleDateString('en-AU') }</figcaption>
                          }

                          {
                            item.location !== null &&
                            <figcaption className="search-list__item-text">Location: { item.location }</figcaption>
                          }

                          {
                            item.first_name !== null &&
                            <figcaption className="search-list__item-text">Sighting by: { item.first_name } { item.surname }</figcaption>
                          }

                          {
                            item.more_information !== null &&
                            <figcaption className="search-list__item-text" title={ item.more_information }>{ item.more_information }</figcaption>
                          }
                          
                          <figcaption className="search-list__item-text">
                            {
                              item.verified &&
                              <span className="badge" title="This sighting is verified">Verified</span>
                            }

                            { 
                              item.status !== null &&
                              <span className={ `badge ${ item.status === 'Healthy' ? 'badge--success' : item.status === 'Dead' || item.status === 'Deceased' ? 'badge--danger' : 'badge--info' }` } title={ `This Koala's satus is ${ item.status }` }>{ item.status }</span>
                            }
                            
                            {
                              item.with_joey &&
                              <span className="badge" title="This Koala is with a Joey">With joey</span>
                            }
                          </figcaption>
                          
                        </figure>
                        <div className="search-list__item-controls">
                          <span onClick={ () => dispatch(showEditKoalaSighting(item)) } title="Edit this sighting" className="button button--reduced">Edit</span>
                        </div>
                      </li>
                    ))
                  ) :
                  (
                    <p style={{ marginTop: 20 }}>No matching sightings.</p>
                  )
                }
              </>
            }
          </ul>
        )
      }

      {
        sightingList?.length > 0 &&
        <div className="pagination">
          {
            currentPage > 1 &&
            <span title="Previous page" className="pagination__direction" onClick={ () => _prevPage() }><i className="fas fa-chevron-left"></i></span>
          }
          <span className="pagination__content">Page { currentPage } of { totalPages }</span>
          {
            totalPages > 1 &&
            <span title="Next page" className="pagination__direction" onClick={ () => _nextPage() }><i className="fas fa-chevron-right"></i></span>
          }
        </div>
      }
      
    </>
  );

}

export default SightingList;